import { Helmet } from "react-helmet-async";
import { useTranslation } from "@/i18n/useTranslation";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  lang?: string;
}

const SITE = "https://eastwestit.dk";
const IMAGE = `${SITE}/og-image.jpg`;

const SEO = ({ title, description, path }: SEOProps) => {
  const { lang } = useTranslation();
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={IMAGE} />
      <meta property="og:locale" content={lang === "da" ? "da_DK" : "en_GB"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={IMAGE} />
    </Helmet>
  );
};

export default SEO;
